<template>
  <v-carousel v-model="model" light hide-delimiters :show-arrows="false" height="auto">
    <v-carousel-item>
      <reporting-product-table @templateSelected="showPrintOptions"/>
    </v-carousel-item>
    <!-- <v-carousel-item> 
        <print-books-options @returnToTemplates="showTemplates" ref="printOptions"/>
    </v-carousel-item> -->
  </v-carousel>
</template>

<script>
import ReportingProductTable from './ReportingProductTable.vue';
export default {
  components: { ReportingProductTable },
  name: "ReportingProductHome",
  data() {
    return {
      model: 0,
    };
  },
  methods: {
      showPrintOptions(){
          this.model = 1;
      },
      showTemplates(){
        this.$refs.printOptions.resetValues();
        this.model = 0;
      }
  }
};
</script>